var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["giftcard/header.j2"] = require( "giftcard/header.j2" );
dependencies["giftcard/form.j2"] = require( "giftcard/form.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/giftcard/balance.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "help/templates/giftcard/balance.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("helpUrl")) {
var t_4 = t_1.helpUrl;
} else {
cb(new Error("cannot import 'helpUrl'")); return;
}
context.setVariable("helpUrl", t_4);
output += "\n\n";
env.getTemplate("macros/form-validation.j2", false, "help/templates/giftcard/balance.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("displayGeneralErrors")) {
var t_8 = t_5.displayGeneralErrors;
} else {
cb(new Error("cannot import 'displayGeneralErrors'")); return;
}
context.setVariable("displayGeneralErrors", t_8);
if(t_5.hasOwnProperty("displayFieldErrors")) {
var t_9 = t_5.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_9);
if(t_5.hasOwnProperty("hasErrors")) {
var t_10 = t_5.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_10);
if(t_5.hasOwnProperty("validatedField")) {
var t_11 = t_5.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_11);
output += "\n\n\n<div class=\"c-card-balance dom-gift-card-balance\">\n\n    <div class=\"o-column o-extra-small--12 o-large--8\">\n\n        ";
env.getTemplate("giftcard/header.j2", false, "help/templates/giftcard/balance.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
output += t_13
output += "\n\n    </div>\n\n    <div class=\"o-column o-extra-small--12 o-large--8\">\n\n        ";
env.getTemplate("giftcard/form.j2", false, "help/templates/giftcard/balance.j2", null, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
output += "\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/giftcard/balance.j2"] , dependencies)